import { useCallback, useContext } from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

import { Button } from '~/components/Button'
import { demoStudentEvaluationsRoute } from '~/routes/routes'

import { studentEvaluationDemoContext } from '../../../..'
import { formsLayoutContext } from '../../../../layout'
import { EditModal } from './compoenents/EditModal'

export const SeriesEdit: React.FC = () => {
  const navigate = useNavigate()
  const { scrollToTop } = useContext(formsLayoutContext)

  const { data: evaluation } = useContext(studentEvaluationDemoContext)

  const handleSave = useCallback(async () => {
    // todo?
  }, [])

  const handleGoBack = useCallback(() => {
    navigate(`/${demoStudentEvaluationsRoute}/prescricao_de_exercicios`, {
      replace: true,
    })
    scrollToTop()
  }, [navigate, scrollToTop])

  return (
    <div className='flex flex-col px-6 py-9 gap-6 rounded-2xl bg-white'>
      {!evaluation?.periodizedSeries?.length ? (
        <p className='px-4 py-2 bg-red-100 rounded-lg'>
          Nenhuma série iniciada. Volte para o item 7 (Agendamento) e selecione
          uma quantidade de séries dentro do campo &quot;Exercícios de
          Força&quot;.{' '}
          <b>
            Caso não seja de seu interesse iniciar uma série, você pode ignorar
            esta etapa clicando diretamente em &quot;Salvar e ir para plano de
            treino&quot;
          </b>
        </p>
      ) : null}
      {evaluation?.periodizedSeries.map((series) => (
        <div
          key={`data-test-${series.letter}`}
          className='flex flex-col gap-4 border border-slate-200 rounded-xl p-4'
        >
          <div className='flex flex-wrap gap-4'>
            <div className='flex flex-col shrink-0'>
              <h2 className='text-xl'>Série {series.letter}</h2>
              <p>Descrição: {series.description || '*sem descrição*'}</p>
            </div>
          </div>
          <div className='flex flex-col gap-6'>
            {series.exercises.map((exercise, index) => (
              <div
                key={`series-${series.letter}-${index}`}
                className='flex flex-col bg-gpa-blue-50 p-4 rounded-lg border border-slate-400'
              >
                <div className=''>
                  <span className='text-lg font-semibold'>{exercise.name}</span>
                </div>
                <div className='flex flex-col gap-4'>
                  <div className='flex flex-wrap gap-3'>
                    <span>Carga Inicial {exercise.initialCharge}</span>
                    <span>Carga Máxima {exercise.maximumCharge}</span>
                    <span>Séries {exercise.numSeries}</span>
                    <span>Repetições {exercise.repetitions}</span>
                    <span>Intervalo {exercise.interval}</span>
                    <span>Velocidade {exercise.speed}</span>
                    <span>Ajuste/Obs {exercise.adjustments}</span>
                  </div>

                  <div className='flex flex-wrap gap-3 self-end'>
                    <EditModal series={series} exercise={exercise} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className='flex justify-between w-full'>
        <Button type='button' onClick={handleGoBack}>
          <FiChevronLeft size={24} />
          <span className='mb-1'>Voltar</span>
        </Button>
        <Button loadingMessage='Salvando...' onClick={handleSave}>
          <span className='mb-1'>Salvar e ir para plano de treino</span>
          <FiChevronRight size={24} />
        </Button>
      </div>
    </div>
  )
}
